import React from "react";
import { CustomDropDown, CustomForm, CustomInput } from "../../shared/Input/AllInputs";
import CustomImageInput from "../../shared/Input/CustomImageInput";
import PrimaryButton, { PrimaryButtonOutlined } from "../../shared/Button/PrimaryButton";
import CustomCard from "../../shared/Card/CustomCard";
import CustomViewImage from "../../shared/Image/CustomViewImage";
import ItemsTable from "../Services/ItemsTable";
import { confirmDialog } from "primereact/confirmdialog";
import StyleGuideContainer from "./StyleGuideContainer";

const StyleGuideDetails = () => {
    const { history, data, setData, handleChange, onSubmit } = StyleGuideContainer();

    const statusOptions = [
        { name: "Pending", value: "PENDING" },
        { name: "Confirmed", value: "CONFIRMED" },
        { name: "Expert Assigned", value: "EXPERT_ASSIGNED" },
        { name: "Processing", value: "PROCESSING" },
        { name: "Completed", value: "COMPLETED" },
    ];

    const onOptionChange = (e) => {
        confirmDialog({
            message: `Are you sure you want to change status to "${e.originalEvent.target.innerText}"?`,
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            accept: () => handleChange({ name: e.name, value: e.target.value }),
            reject: () => null,
        });
    };

    const removeReworkAfterImage = (index) => {
        const updatedReWorks = [...data?.reWorks];
        updatedReWorks[index].afterImage = ""; // Set afterImage to an empty string
        setData(() => ({ ...data, reWorks: updatedReWorks })); // Update the state
    };

    return (
        <>
            <CustomCard title={"Order Details - " + (data?.projectName ?? "")}>
                <CustomForm>
                    <CustomInput disabled col={5} key="fullName" label="User Name" name="fullName" value={data?.personalInfo?.fullName} />
                    <CustomInput disabled col={5} key="email" label="User Email" name="email" value={data?.personalInfo?.email} />
                    {data?.images?.map((img, index) => (
                        <>
                            <div className="flex flex-column w-full surface-100 border-round-xl p-4 mb-3">
                                <h3 className="my-auto">Area: </h3>
                                <h5 className="my-auto mb-4"> {img?.area}</h5>
                                <div className="flex mt-5 gap-8">
                                    <CustomViewImage image={img?.beforeImage}></CustomViewImage>
                                    <CustomImageInput
                                        name="afterImage"
                                        label="After Image"
                                        formArrayName="images"
                                        index={index}
                                        data={img}
                                        editable={true}
                                        onFilesChange={handleChange}
                                    />
                                </div>

                                <div className="mb-3">
                                    <ItemsTable heading={"Service Items"} items={img?.items} showActions={false} />
                                </div>
                                <div className="mb-3">
                                    <ItemsTable heading={"Additional Services"} items={img?.additionalServices} showActions={false} />
                                </div>
                            </div>
                        </>
                    ))}

                    {data?.isRework ? (
                        <div className="flex flex-column w-full surface-100 border-round-xl p-4 mb-3">
                            <h3 className="my-auto">Reworks: </h3>
                            {data?.reWorks?.map((rework, index) => (
                                <>
                                    <div className="flex flex-column w-full surface-100 border-round-xl p-4 mb-3">
                                        <h3 className="my-auto">Comment: </h3>
                                        <h5 className="my-auto mb-4"> {rework?.comment}</h5>
                                        <div className="flex mt-5 gap-8">
                                            <CustomViewImage image={rework?.beforeImage}></CustomViewImage>
                                            {rework?.afterImage ? (
                                                <div className="flex">
                                                    <CustomViewImage image={rework?.afterImage} />
                                                    <i className="pi pi-times cursor-pointer" onClick={() => removeReworkAfterImage(index)}></i>
                                                </div>
                                            ) : (
                                                <CustomImageInput
                                                    name="afterImage"
                                                    label="After Image"
                                                    formArrayName="reWorks"
                                                    index={index}
                                                    data={rework}
                                                    editable={true}
                                                    onFilesChange={handleChange}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </>
                            ))}
                        </div>
                    ) : null}

                    <CustomInput disabled col={6} key="totalPrice" label="Total Price" name="totalPrice" value={"$" + data?.totalPrice} />
                    <CustomDropDown
                        col={6}
                        label={"Staus"}
                        name={"status"}
                        invalid
                        value={data?.status}
                        options={statusOptions}
                        optionLabel="name"
                        optionValue="value"
                        placeholder=""
                        onChange={(e) => onOptionChange(e)}
                        extraClassName="w-5"
                    />
                </CustomForm>
                <div className="flex justify-content-end">
                    <PrimaryButton label={"Update"} extraClassName={"w-3"} onClick={onSubmit}></PrimaryButton>
                    <PrimaryButtonOutlined
                        label="Cancel"
                        extraClassName={"w-3"}
                        onClick={() => history.push("/style-guides")}
                    ></PrimaryButtonOutlined>
                </div>
            </CustomCard>
        </>
    );
};

export default StyleGuideDetails;
